module.exports = __webpack_public_path__ + "img/Five_engine.a26f5db4.jpg";